<template>
    <ConfirmDialog group="dialog" />
    <Toast />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('PositionOffer.Details.Heading') }}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Name') }} :</label>
                    <div class="p-col-12 p-md-10">{{ name === null ? 'N/A' : name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Gender') }} :</label>
                    <div class="p-col-12 p-md-10">{{ gender === null ? 'N/A' : $t(gender) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Age') }} :</label>
                    <div class="p-col-12 p-md-10">{{ age_in_years === null ? 'N/A' : age_in_years }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Phone') }} :</label>
                    <div class="p-col-12 p-md-10">{{ formatPhoneNumber(phone_number) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Email') }} :</label>
                    <div class="p-col-12 p-md-10">{{ email }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.HomeAddress') }} :</label>
                    <div class="p-col-12 p-md-10">{{ address === null ? 'N/A' : address }}</div>
                </div>
                <hr />
                <div class="p-field p-grid p-align-start" v-if="memo_infos !== null && !isHidden">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Note') }} :</label>
                    <div class="p-col-12 p-md-10">{{ memo_infos == null ? 'N/A' : memo_infos }}</div>
                </div>

                <div class="p-field p-grid" v-else-if="memo_infos === null">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Note') }}</label>
                    <div class="textbox p-col-12 p-md-12" :style="error?.note ? 'border: 1px solid red' : ''">
                        <Textarea :placeholder="$t('PositionOffer.Details.Desc')" :autoResize="true" rows="5" cols="30" v-model="memo_info" style="width: 100%; margin-left: 0px; margin-top: 14px" id="areatext" @keydown.space="preventLeadingSpace" maxlength="500"/>
                        <span class="img-info">{{ $t('PositionOffer.Details.NoteInfo') }}</span>
                    </div>
                    <div class="text-red">{{ error.note }}</div>
                </div>
                <div class="p-field p-grid" v-if="isHidden">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('PositionOffer.Details.Note') }}</label>
                    <div class="textbox p-col-12 p-md-12" :style="error?.note ? 'border: 1px solid red' : ''">
                        <Textarea
                            :placeholder="$t('PositionOffer.Details.Desc')"
                            :autoResize="true"
                            rows="5"
                            cols="30"
                            maxlength="500"
                            v-model="memo_info"
                            style="width: 100%; margin-left: 0px; margin-top: 14px"
                            id="areatext"
                            @keydown.space="preventLeadingSpace"
                        />
                        <span class="img-info">{{ $t('PositionOffer.Details.NoteInfo') }}</span>
                    </div>
                    <div class="text-red">{{ error.note }}</div>
                </div>
                <div class="p-col-12" v-if="!isHidden && memo_infos !== null">
                    <div class="p-d-flex p-jc-between">
                        <!-- <div style="margin-left: -12px">
                            <Button @click="Update" :label="$t('PositionOffer.Details.Save')" class="p-button-outlined p-button-success p-mr-2 p-mb-2" style="background: black; color: white" icon="pi pi-check" iconPos="left"></Button>
                        </div> -->
                        <div style="margin-left: -12px">
                            <Button
                                v-on:click="isHidden = !isHidden"
                                :label="$t('PositionOffer.Details.EditNote')"
                                class="p-button-outlined p-button-success p-mr-2 p-mb-2"
                                style="background: black; color: white"
                                icon="pi pi-pencil"
                                iconPos="left"
                            ></Button>
                        </div>
                        <div id="back">
                            <Button @click="$router.go(-1)" :label="$t('PositionOffer.Details.Back')" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-replay" iconPos="left" style="background: white; color: black" />
                        </div>
                    </div>
                </div>
                <div class="p-col-12" v-else>
                    <div class="p-d-flex p-jc-between">
                        <div style="margin-left: -12px; margin-top: 0px">
                            <Button @click="Update" :label="$t('PositionOffer.Details.Save')" class="p-button-outlined p-button-success p-mr-2 p-mb-2" style="background: black; color: white" icon="pi pi-check" iconPos="left"></Button>
                        </div>
                        <!-- <div style="margin-left: -12px">
                            <Button v-on:click="isHidden = !isHidden" :label="$t('PositionOffer.Details.EditNote')" class="p-button-outlined p-button-success p-mr-2 p-mb-2" style="background: black; color: white" icon="pi pi-pencil" iconPos="left"></Button>
                        </div> -->
                        <div id="back">
                            <Button @click="$router.go(-1)" :label="$t('PositionOffer.Details.Back')" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-replay" iconPos="left" style="background: white; color: black" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
// import ProductCategoryService from '../../../service/API/ProductCategoryService';
import PositionOfferService from '../../service/API/PositionOfferService';
import moment from 'moment';
// import validatePurchaseNote from '../../validations/Purchase/validatePurchaseNote';
// import {useRouter} from 'vue-router'
export default {
    data() {
        return {
            disInq: true,
            renderTxt: false,
            replied: false,
            replyText: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},

            name: '',

            email: '',
            id: '',
            gender: '',
            phone_number: '',
            memo_info: '',
            error: {},
            validity: '',
            status: '',
            memo_infos: '',
            isHidden: false,
        };
    },
    created() {
        this.positionOfferService = new PositionOfferService();
    },
    methods: {
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },
        Update() {
            // let vcheckData = {

            //     note: this.note,
            //     // type: this.dropdownValueType == null ? '' : 'something',
            // };
            // const { isInvalid, error } = validatePurchaseNote(vcheckData);
            // if (isInvalid) {
            //     this.error = error;
            //     console.log(error);
            // } else {
            //     console.log(this.formData);
            return axios.post('api/v1/admin/position-offer/update-memo', { user_id: this.$route.params.id, memo_info: this.memo_info }).then(() => {
                // alert('성공적으로 저장');
                // this.$toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Succesfully Published.', life: 3000 });
                this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '구매 정보가 저장되었습니다.', life: 3000 });

                setTimeout(() => {
                    window.location.reload();
                }, 500);

                // this.$router.push({ name: 'JobSeeker Details' });
            });
            // }
        },

        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            } else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            } else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
    },
    mounted() {
        this.positionOfferService.GetJobSeekerDetails(this.$route.params.id).then((result) => {
            console.log(result);
            this.name = result.name;
            this.email = result.email;
            this.age_in_years = result.age_in_years;
            this.phone_number = result.phone_number;
            this.address = result.address;
            this.memo_info = result.memo_info;
            this.gender = result.gender;
            this.memo_infos = result.memo_info;
            // this.main_original_price = result[0].main_original_price;
            // this.discount_price = result[0].discount_price;
            // this.main_price = result[0].main_price;
            // this.sub_type = result[0].sub_type;
            // this.created_at = result[0].created_at;
            // this.industry_name = result[0].industry_name;
            // this.cases = result[0].cases;
            // this.is_gifted = result[0].is_gifted;
            // this.is_refunded = result[0].is_refunded;
            // this.ad_package_id = result[0].ad_package_id;
            // this.ad_status = result[0].ad_status;
            // this.status = data.status;
            // this.mydata = data;
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}

.select {
    flex-wrap: wrap;
    margin-right: -1rem;
    margin-left: -1rem;
}

#areatext {
    height: 34vh;
}

div#back {
    margin-right: -20px;
}
</style>
